

module.exports = __webpack_require__.stylable.create(
    "ShippingSectionOverride2744120531",
    {"classes":{"root":"ShippingSectionOverride2744120531__root","title":"ShippingSectionOverride2744120531__title","text":"ShippingSectionOverride2744120531__text","lineBreak":"ShippingSectionOverride2744120531__lineBreak","wrapper":"ShippingSectionOverride2744120531__wrapper"},"vars":{},"stVars":{"titleTextColor":"'\"color(--thankYou_titleColor)\"'","titleTextFont":"'\"font({theme: 'thankYou_titleFontStyle', size: '16px', lineHeight: '24px'})\"'","textColor":"'\"color(--thankYou_textColor)\"'","textFont":"'\"font({theme: 'thankYou_textFontStyle', size: '16px', lineHeight: '24px'})\"'"},"keyframes":{}},
    "",
    14,
    "ShippingSectionOverride2744120531",
    null
);
